/** Editor del compose e dell'environment. */
export const editor = {
  "editor.cerca": "Cerca nel testo",
  "editor.sostituisciCon": "Sostituisci con",
  "editor.successiva": "successiva",
  "editor.precedente": "precedente",
  "editor.tutte": "tutte",
  "editor.maiuscole": "maiuscole",
  "editor.regex": "regex",
  "editor.parolaIntera": "parola intera",
  "editor.sostituisci": "sostituisci",
  "editor.sostituisciTutte": "sostituisci tutte",
  "editor.chiudi": "chiudi",
  "editor.righeRipiegate": "Righe ripiegate",
  "editor.righeAperte": "Righe aperte",
  "editor.ripiega": "Ripiega",
  "editor.apri": "Apri",
  "editor.copiaTutto": "Copia tutto negli appunti",
  "editor.cercaScorciatoia": "Cerca nel testo (Ctrl+F)",
  "editor.schermoIntero": "Apri a schermo intero",
  "editor.titolo": "Editor",
  "editor.aiutoSchermoIntero": (p: { righe: number }) => `${p.righe} righe · Ctrl+F cerca · Esc esce`,

  "env.testoAiuto": "Una variabile per riga, nel formato CHIAVE=valore. Comodo per incollare un blocco intero.",
  "env.nessunaMancante": "Nessuna variabile mancante: il compose ha tutto ciò che gli serve.",
  "env.mancantiAiuto":
    "Variabili che il compose richiede e che nessuno ha ancora impostato: senza un valore, l'avvio si fermerebbe qui.",
  "env.filtroSegnaposto": "Filtra per nome o valore",
  "env.filtro": "Filtra le variabili",
  "env.filtrate": (p: { n: number; totale: number }) => `${p.n} di ${p.totale}`,
  "env.aggiungineUna": "Aggiungine una con il pulsante qui sotto.",
  "env.nessunaCorrisponde": (p: { filtro: string }) => `Nessuna variabile corrisponde a "${p.filtro}".`,
  "env.assegnataAvvio": "assegnata all'avvio",
  "env.gestita": "gestita da Portman",
  "env.aggiungi": "Aggiungi variabile",
  "env.mancanti": "Mancanti",
  "env.testo": "Testo",
  "env.statoInutilizzata": "definita ma non usata dal compose",
  "env.statoRichiesta": "richiesta dal compose",
  "env.chiave": "CHIAVE",
  "env.nelCompose": "nel compose",
  "env.nonUsata": "non usata",
  "env.nascosto": "nascosto",
  "env.rimuovi": (p: { nome: string }) => `Rimuovi ${p.nome}`,
  "env.variabile": "variabile",
};
